<template>
  <window-portal :open="data.show" @close="onClose">
    <div style="position: relative;">
      <div style="position: sticky; left: 0; right: 0; top: 0; width: 100%; background-color: white; text-align: center;">
        <div style="padding: 8px; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 1.5rem;">
          Vista previa de Impresión
        </div>
        <div class="d-flex justify-center" style="padding-bottom: 12px;">
          <button style="margin-right: 8px;" @click="downloadPdf">Descargar</button>
          <button @click="printPdf">Imprimir</button>
        </div>
      </div>
      <div style="display: flex; justify-content: center; background-color: grey; overflow: auto;">
        <div v-if="data.pdfUrl" style="width: 816px; border: 1px solid grey;">
          <vue-pdf-embed :source="data.pdfUrl" width="816"/>
        </div>
        <div v-else>Cargando pdf...</div>
      </div>
    </div>
  </window-portal>
</template>

<script>
import WindowPortal from "@/components/ReportsAndPrintings/WindowPortal.vue";
import {
  page,
  table,
  font,
  text,
  width,
} from "@/components/PreviewDocument/styles.js";
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

export default {
  name: "HospitalizationForm",

  model: {
    event: "update",
    prop: "data",
  },

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  components: { WindowPortal, VuePdfEmbed },

  data: () => ({
    loading: false,
    maxRowsPerPage: 30,
    header: "",
    footer: "",
    previewConfig: {
      title: "Vista Previa de Impresión de Libro Diario",
      filename: "Hospitalización.pdf",
      margins: [10, 20, 10, 20],
      unit: "mm",
      format: "letter",
      orientation: "portrait",
    },
    pagesData: [[]],
    style: {
      page,
      table,
      font,
      text,
      width,
      textTitle: { ...font.bold, ...text.center },
      textHeader: { ...font.bold, "margin-top": "20px" },
      tableHeader: { ...font.s12, ...text.left },
      tableHeaderCenter: { ...font.s12 },
      tableData: { ...font.s12, "padding-top": "3px", "padding-bottom": "3px" },
      tableDataRight: {
        ...font.s12,
        ...text.right,
        "padding-top": "3px",
        "padding-bottom": "3px",
      },
    },
  }),

  computed: {
    totalPages() {
      return this.pagesData.length;
    },
  },

  mounted() {
    this.getHeaderFooter();
  },

  methods: {
    printPdf() {
      const printWindow = window.open(this.data.pdfUrl);
      printWindow.onload = function() {
        printWindow.focus();
        printWindow.print();
      };
    }, 
    downloadPdf() {
      const link = document.createElement('a');
      link.href = this.data.pdfUrl;
      link.download = `Reporte-hospitalizacion-hospedaje.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    onClose() {
      const data = this.$clone(this.data);
      data.show = false;
      this.$emit("update", data);
    },
    getHeaderFooter() {
      this.$API.HF.getHF().then((data) => {
        let header = [],
          footer = [];
        header = data.filter((x) => x.State == "1" && x.Type == "Header");
        this.header = header.length > 0 ? JSON.parse(header[0].Body).html : "";
        this.header = this.header.replace(/(\n)/gm, "");
        footer = data.filter((x) => x.State == "1" && x.Type == "Footer");
        this.footer = footer.length > 0 ? JSON.parse(footer[0].Body).html : "";
      });
    },
    getCurrentPageData(pagesData, increment = 1) {
      // get last page
      const currPage = pagesData[pagesData.length - 1];

      // get content length
      const currLength = currPage.reduce(
        (accum, item) => accum + item.content.length + (item.title ? 1 : 0),
        0
      );

      // create new page when limit is reached
      if (currLength + increment > this.maxRowsPerPage) {
        pagesData.push([]);
        // return last page
        return pagesData[pagesData.length - 1];
      }
      return currPage;
    },
    getSection(currPage, section) {
      // if new page, start with empty content and not show section title
      if (!currPage.length) {
        const section_ = this.$clone(section);
        section_.title = "";
        section_.content = [];
        currPage.push(section_);

        // return new last section
        return currPage[currPage.length - 1];
      }

      // return last section
      return currPage[currPage.length - 1];
    },
    setHospitalizationHostedContent(pagesData) {
      const { hospitalized, hosted, hostedSubTotal, hospitalizedSubTotal } =
        this.data.data;

      // section data
      const section1 = {
        type: "section",
        title: "1. Hospitalización u hospedaje",
        id: "1",
        content: [],
      };

      // hospitalized content
      const content = [
        [
          {
            title: "Hospitalizado",
            value: hospitalized.status ? "Sí" : "No",
            style: font.bold,
          },
          { title: "", value: "" },
        ],
      ];
      if (hospitalized.status) {
        content[0].title = "Servicio";
        content[0].value = hospitalized.Name;
        content.push([
          { title: "Tarifa diaria", value: hospitalized.price },
          { title: "Días", value: hospitalized.days },
        ]);
        content.push([
          {
            title: "Subtotal",
            value: hospitalizedSubTotal,
            style: font.underline,
          },
          { title: "", value: "" },
        ]);
      }

      // hosted content
      content.push([
        {
          title: "Hospedado",
          value: hosted.status ? "Sí" : "No",
          style: font.bold,
        },
        { title: "", value: "" },
      ]);
      if (hosted.status) {
        content[content.length - 1].title = "Servicio";
        content[content.length - 1].value = hosted.Name;

        content.push([
          { title: "Tarifa diaria", value: hosted.price },
          { title: "Días", value: hosted.days },
        ]);
        content.push([
          { title: "Subtotal", value: hostedSubTotal, style: font.underline },
          { title: "", value: "" },
        ]);
      }

      // add section to content
      this.getCurrentPageData(pagesData).push(section1);

      // set content by rows
      for (const row of content) {
        const currPage = this.getCurrentPageData(pagesData);
        const section = this.getSection(currPage, section1);
        section.content.push(row);
      }
    },
    setMedications1(pagesData) {
      const { serviceToInvoice1, medicationsSubTotal1, medications1 } =
        this.data.data;

      // section data
      const section2 = {
        type: "section",
        title: "2. A) Mediamentos y otros aplicados",
        id: "2a",
        content: [],
      };

      const content = [{ type: "service", value: serviceToInvoice1 }];

      for (const medication of medications1) {
        content.push({ type: "data", data: medication });
      }

      content.push({ type: "subtotal", value: medicationsSubTotal1 });

      // add section to content
      this.getCurrentPageData(pagesData).push(section2);

      // first data flag
      let firstData = false;

      // set content by rows
      for (const row of content) {
        const currPage = this.getCurrentPageData(pagesData);
        const section = this.getSection(currPage, section2);

        if (!section.content.length) {
          firstData = false;
        }
        // mark first data record for each page
        if (!firstData && row.type === "data") {
          firstData = true;
          row.firstData = firstData;
        }
        section.content.push(row);
      }
    },
    setMedications2(pagesData) {
      const { serviceToInvoice2, medicationsSubTotal2, medications2 } =
        this.data.data;

      // section data
      const section3 = {
        type: "section",
        title: "2. B) Mediamentos de farmacia y otros accesorios",
        id: "2b",
        content: [],
      };

      const content = [{ type: "service", value: serviceToInvoice2 }];

      for (const medication of medications2) {
        content.push({ type: "data", data: medication });
      }

      content.push({ type: "subtotal", value: medicationsSubTotal2 });

      // add section to content
      this.getCurrentPageData(pagesData).push(section3);

      // first data flag
      let firstData = false;

      // set content by rows
      for (const row of content) {
        const currPage = this.getCurrentPageData(pagesData);
        const section = this.getSection(currPage, section3);

        if (!section.content.length) {
          firstData = false;
        }
        // mark first data record for each page
        if (!firstData && row.type === "data") {
          firstData = true;
          row.firstData = firstData;
        }
        section.content.push(row);
      }
    },
    setServices(pagesData) {
      const { servicesSubTotal, services } = this.data.data;

      // section data
      const section4 = {
        type: "section",
        title: "3. Otros servicios",
        id: "3",
        content: [],
      };

      const content = [];

      for (const medication of services) {
        content.push({ type: "data", data: medication });
      }

      content.push({ type: "subtotal", value: servicesSubTotal });

      // add section to content
      this.getCurrentPageData(pagesData).push(section4);

      // first data flag
      let firstData = false;

      // set content by rows
      for (const row of content) {
        const currPage = this.getCurrentPageData(pagesData);
        const section = this.getSection(currPage, section4);

        if (!section.content.length) {
          firstData = false;
        }
        // mark first data record for each page
        if (!firstData && row.type === "data") {
          firstData = true;
          row.firstData = firstData;
        }
        section.content.push(row);
      }
    },
    async calculatePagesOfDoc() {
      const { total } = this.data.data;
      const pagesData = [[]];

      // hospitalization or hosted section content calculations
      this.setHospitalizationHostedContent(pagesData);
      this.setMedications1(pagesData);
      this.setMedications2(pagesData);
      this.setServices(pagesData);

      // total section
      const section5 = {
        type: "section",
        title: "",
        id: "4",
        content: [{ type: "total", value: total }],
      };
      // add section to content
      this.getCurrentPageData(pagesData).push(section5);

      this.pagesData = pagesData;
    },
    getSubtotal(days, price) {
      try {
        return (parseFloat(days) * parseFloat(price)).toFixed(2);
      } catch (err) {
        return Number(0).toFixed(2);
      }
    },
  },

  watch: {
    "data.show"(value) {
      if (value) {
        this.calculatePagesOfDoc();
      }
    },
  },
};
</script>
